import React from 'react';
import { string } from 'prop-types';

import { QueryProvider } from '@thd-nucleus/data-sources';

import { BrowseAndSearch } from './BrowseAndSearch';

const browseDefaultVariables = {
  skipInstallServices: false,
  skipSpecificationGroup: false
};

const searchOptsFn = ({ options, queryName }) => {
  if (queryName === 'searchStreamProduct') {
    const variables = options.variables;
    // eslint-disable-next-line no-param-reassign
    options.variables = undefined;
  }
  return options;
};

const searchSkipFn = ({ skip, queryName, attributes }) => {
  if (queryName === 'searchStreamProduct') {
    if (!attributes?.searchModel?.products?._children?.fulfillment) return true;
  }
  return skip;
};

export const BrowseAndSearchContainer = (props) => {

  const { pageType } = props;

  if (pageType === 'browse') {
    return (
      <QueryProvider
        cacheKey="browse-search"
        defaultVariables={browseDefaultVariables}
        queryOptions={searchOptsFn}
        skip={searchSkipFn}
      >
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <BrowseAndSearch {...props} />
      </QueryProvider>
    );
  }

  return (
    <QueryProvider
      cacheKey="browse-search"
      defaultVariables={browseDefaultVariables}
    >
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <BrowseAndSearch {...props} />
    </QueryProvider>
  );

};

BrowseAndSearchContainer.propTypes = {
  pageType: string.isRequired
};
